// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3umWj","importantInfo":"styles_importantInfo__387Xz"};